import React from 'react';

export const VbzIcon = () => {
  return (
    <svg width="76" height="76" viewBox="0 0 76 76" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="76" height="76" rx="16" />
      <path
        d="M50.285 26H26C24.35 26 23.015 27.35 23.015 29V35C24.665 35 26 36.35 26 38C26 39.65 24.665 41 23 41V47C23 48.65 24.35 50 26 50H50C51.65 50 53 48.65 53 47V29C53 27.35 51.785 26 50.285 26ZM46.595 39.95L33.305 43.49L30.815 39.17L32.21 38.795L34.1 40.28L37.685 39.32L34.085 33.08L36.185 32.51L42.2 38.12L45.86 37.145C46.625 36.935 47.42 37.4 47.63 38.165C47.825 38.93 47.375 39.725 46.595 39.95Z"
        fill="white"
      />
    </svg>
  );
};

export const VbzIconExclusive = () => {
  return (
    <svg width="76" height="76" viewBox="0 0 76 76" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="76" height="76" rx="16" fill="white" />
      <path
        d="M50.285 26H26C24.35 26 23.015 27.35 23.015 29V35C24.665 35 26 36.35 26 38C26 39.65 24.665 41 23 41V47C23 48.65 24.35 50 26 50H50C51.65 50 53 48.65 53 47V29C53 27.35 51.785 26 50.285 26ZM46.595 39.95L33.305 43.49L30.815 39.17L32.21 38.795L34.1 40.28L37.685 39.32L34.085 33.08L36.185 32.51L42.2 38.12L45.86 37.145C46.625 36.935 47.42 37.4 47.63 38.165C47.825 38.93 47.375 39.725 46.595 39.95Z"
        fill="#231F20"
      />
    </svg>
  );
};

export const AirplaneIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="34" height="31" viewBox="0 0 34 31" fill="none" className="airplane">
      <g clipPath="url(#clip0_6429_24454)">
        <path d="M11.8483 27.6221L14.5701 27.6221L21.3744 16.9498L28.8591 16.9498C29.9886 16.9498 30.9004 16.1086 30.9004 15.0664C30.9004 14.0243 29.9886 13.1831 28.8591 13.1831L21.3744 13.1831L14.5701 2.51074L11.8483 2.51074L15.2505 13.1831L7.76577 13.1831L5.72448 10.0442L3.68319 10.0442L5.04405 15.0664L3.68319 20.0887L5.72448 20.0887L7.76577 16.9498L15.2505 16.9498L11.8483 27.6221Z" />
      </g>
      <defs>
        <clipPath id="clip0_6429_24454">
          <rect width="30.1337" height="32.6606" transform="translate(33.6211) rotate(90)" />
        </clipPath>
      </defs>
    </svg>
  );
};
